

export const Poster = (props) => { 

  return ( 
    <>
    <div className="poster">
      <div className="poster_header">
        <i className={props.icon}></i>
        {props.header}
      </div>
      <div className="poster_body">
        {props.body}
      </div>
    </div>
    </>
  ); 

} 
